import { getRootVue } from '../../common/baseMain'
import { getRouter } from '../../common/baseRouter'
import ImageBank from '../data/pages/ImageBank.vue'
import SensitiveWordStock from '../data/pages/SensitiveWordStock.vue'
import TaskQuery from '../manage/pages/TaskQuery.vue'
import TaskSummary from '../manage/pages/TaskSummary.vue'
import WorkStat from '../manage/pages/WorkStat.vue'
import ContentManage from '../platform/pages/ContentManage.vue'
import ContentUpload from '../platform/pages/ContentUpload.vue'
import DocPreview from '../platform/pages/DocPreview.vue'
import MyTaskList from '../platform/pages/MyTaskList.vue'
import SubTaskList from '../platform/pages/SubTaskList.vue'
import WeMediaSubTaskList from '../platform/pages/WeMediaSubTaskList.vue'
import PermissionManage from '../settings/pages/PermissionManage.vue'
import UserManage from '../settings/pages/UserManage.vue'
import PreLogin from './SsoSwitchLogin.vue'
import Home from './Home.vue'

// get router config
const router = getRouter({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/platform/my-task',
      component: MyTaskList
    },
    {
      path: '/platform/sub-list',
      component: SubTaskList
    },
    {
      path: '/platform/we-media-sub-list',
      component: WeMediaSubTaskList
    },
    {
      path: '/platform/content-upload',
      component: ContentUpload
    },
    {
      path: '/platform/content-manage',
      component: ContentManage
    },
    {
      path: '/platform/doc-preview',
      component: DocPreview
    },
    {
      path: '/manage/summary',
      component: TaskSummary
    },
    {
      path: '/manage/query',
      component: TaskQuery
    },
    {
      path: '/manage/stat',
      component: WorkStat
    },
    {
      path: '/data/sensitive',
      component: SensitiveWordStock
    },
    {
      path: '/data/image',
      component: ImageBank
    },
    {
      path: '/settings/permission',
      component: PermissionManage
    },
    {
      path: '/settings/user',
      component: UserManage
    },
    {
      path: '/ssoswitch',
      component: PreLogin
    }
  ]
})

// 入口
getRootVue({
  router
})
